

























import { IEntityMapping } from '@/typings/import';
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import TransportationPermission from '@/components/Passenger/models/TransportationPermission';
import TransportationPermissionMapper from '@/components/Importer/transportationPermission/TransportationPermissionMapper.vue';
import TransportationPermissionMapping from '@/components/Importer/models/transportationPermission/TransportationPermissionMapping';

@Component({
  components: {
    TransportationPermissionMapper
  },
})
export default class TransportationPermissionsMapper extends Vue {
  mappings: Array<IEntityMapping<TransportationPermission>> = [];
  showMappings: boolean = true;

  @Prop({ required: true }) value: Array<IEntityMapping<TransportationPermission>>;

  @Watch('value', { immediate: true }) onValueChanged() {
    this.mappings = this.value;
  }

  handleMappingChanged(mapping: IEntityMapping<TransportationPermission>, index: number) {
    this.mappings.splice(index, 1, mapping);
    this.$emit('input', this.mappings);
  }

  addMapping() {
    const firstMapping = this.mappings.find(x => x);
    let configs = null;
    if (firstMapping) {
      // Give the new mapper passenger matching properties from the previous one
      configs = {};
      firstMapping.props
        .filter(p => TransportationPermissionMapping.NON_ENTITY_MAPPINGS.includes(p.propertyName))
        .filter(p => p.propertyName !== TransportationPermissionMapping.ENTITY_CREATION_MAPPING)
        .forEach(p => {
          configs[p.propertyName] = JSON.parse(JSON.stringify(p));
        });
    }

    const newMapping = new TransportationPermissionMapping(configs);
    this.mappings.push(newMapping);
    this.$emit('input', this.mappings);
  }

  removeMapping(index: number) {
    this.mappings.splice(index, 1);
    this.$emit('input', this.mappings);
  }

}
